const DEFAULT_MESSAGE = "Loading, please wait";

let activeCount = 0;
let currentMessage = DEFAULT_MESSAGE;
const listeners = new Set();

const notify = () => {
  const state = getLoadingState();
  listeners.forEach((listener) => listener(state));
};

export const startLoading = (message) => {
  activeCount += 1;
  if (message) {
    currentMessage = message;
  }
  notify();
};

export const stopLoading = () => {
  activeCount = Math.max(0, activeCount - 1);
  if (activeCount === 0) {
    currentMessage = DEFAULT_MESSAGE;
  }
  notify();
};

export const setLoadingMessage = (message) => {
  currentMessage = message || DEFAULT_MESSAGE;
  notify();
};

export const getLoadingState = () => ({
  isLoading: activeCount > 0,
  message: currentMessage,
});

export const subscribeToLoading = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const DEFAULT_LOADING_MESSAGE = DEFAULT_MESSAGE;
